import React, {} from 'react';
import styles from './MenuLojista.module.scss';
import { Link } from 'react-router-dom';
import { cognitoSignOut } from 'shared/services/aws/cognito';
import { useAuth } from 'shared/contexts/Auth/AuthContext';
import { User,ChartSpline, Store, PackageSearch, Truck, UsersRound, Landmark, 
         BadgeDollarSign, Settings, LogOut} from "lucide-react";
interface MenuProps {
  handleClose: () => void;
}

export const MenuLojista: React.FC<MenuProps> = ({ handleClose }) => {
  const { user }=useAuth();

  async function handleLogout(){
   await cognitoSignOut();
   handleClose();
  }

  return (
    <div className={styles.menu}>

      <div className={styles.menuContainer}>
          <Link to="/"  onClick={handleClose} >
            <img className={styles.logoEmpresa} src='/imagens/menuLogo.png' alt="Logo" />
          </Link>
          <Link to="/arealojista/perfillojista" className={styles.menuOption}  onClick={handleClose} >
            <User size={16} />
            <p className={styles.pOption}>Perfil</p>
          </Link>
          <Link to="/arealojista/metricas" className={styles.menuOption}  onClick={handleClose} >
            <ChartSpline size={16} />
            <p className={styles.pOption}>Métricas</p>
          </Link>
          <Link to="arealojista/lojas" className={styles.menuOption} onClick={handleClose} >
            <Store size={16} />
            <p className={styles.pOption}>Lojas </p>
          </Link>
          <Link to="/arealojista/produtos" className={styles.menuOption} onClick={handleClose} >
            <PackageSearch size={16} />
            <p className={styles.pOption}>Produtos </p>
          </Link>
          <Link to="/arealojista/entregas" className={styles.menuOption} onClick={handleClose} >
            <Truck size={16} />
            <p className={styles.pOption}>Entregas</p>
          </Link>
          <Link to="/arealojista/clientes" className={styles.menuOption} onClick={handleClose} >
            <UsersRound size={16} />
            <p className={styles.pOption}>Clientes</p>
          </Link>
          <Link to="/arealojista/vendas" className={styles.menuOption} onClick={handleClose} >
            <BadgeDollarSign size={16} />
            <p className={styles.pOption}>Vendas</p>
          </Link>
          <Link to="/arealojista/vendas" className={styles.menuOption} onClick={handleClose} >
            <Landmark size={16} />
            <p className={styles.pOption}>Dados Bancários</p>
          </Link>
          <Link to="/arealojista/configuracoes" className={styles.menuOption} onClick={handleClose} >
            <Settings size={16} />
            <p className={styles.pOption}>Configurações </p>
          </Link>
      </div>
      <div className={styles.containerSair} >
        {user && ( // Verifica se o usuário está cadastrado

        <button className={styles.menuSair} onClick={handleLogout}>
          <LogOut size={16} />
          <p className={styles.pSair}>Sair </p>
        </button>
        )}
      </div>
    </div>
  );
};
